

interface MyInsightsState {
    isLoading: boolean;
    error: string | null;
}



const initialState: MyInsightsState = {

    isLoading: false,
    error: null
};

const MyInsightsReducer = (state = initialState, action: { type: string; payload?: any }): MyInsightsState => {
    switch (action.type) {
        default:
            return state;
    }
};

export default MyInsightsReducer;
